import { createSelector } from 'reselect';
import _ from 'lodash';
import getStickySession from 'utils/getStickySession';
import { GetRegion } from 'constants.js';
import { getBrowser } from 'utils/Platform';
import { getHKS as gHKS } from 'utils/HKS';
import { RESPONSE_CONFIG } from '../actions/constantsActions';

const initialState = null;
window.CLARO = {};

export default function configs(state = initialState, action) {
  if (action.type === RESPONSE_CONFIG) {
    window.CLARO.config = action.config;
    return action.config;
  }
  return state;
}

export const getConfig = state => _.get(state, 'config');
export const getMetadata = state => _.get(state, 'metadata', {});

export const getApiBaseURL = createSelector(
  [getConfig],
  config => _.get(config, 'url_dominio_microfwk'),
);

export const getRegion = () => window.utils.userType.checkRegion();

export const getHKS = () => gHKS();

export const getApiConfig = createSelector(
  [
    data => _.get(data, 'data', false) || data || {},
    config =>
      _.get(config, ['data', 'url_dominio_microfwk'], false) ||
      _.get(config, ['url_dominio_microfwk'], {}),
    getHKS,
  ],
  (config, baseURL, HKS) => {
    const region = GetRegion();
    const rest = {
      device_id: 'web',
      device_category: 'web',
      device_model: 'web',
      device_type: 'web',
      device_so: getBrowser(),
      format: 'json',
      device_manufacturer: 'generic',
    };

    const stickySession = getStickySession();

    const defaults = _.pick(config, [
      'authpn',
      'authpt',
      'api_version',
      'user_hash',
    ]);

    const params = _.merge({}, rest, defaults, { region, HKS }, stickySession);

    return {
      params,
      baseURL,
    };
  },
);

export const getApiConfigSticky = createSelector(
  [
    data => _.get(data, 'data', false) || data || {},
    config =>
      _.get(config, ['data', 'url_dominio_microfwk'], false) ||
      _.get(config, ['url_dominio_microfwk'], {}),
    getHKS,
  ],
  (config, baseURL, HKS) => {
    const region = GetRegion();
    const rest = {
      device_id: 'web',
      device_category: 'web',
      device_model: 'web',
      device_type: 'web',
      format: 'json',
      device_so: getBrowser(),
      device_manufacturer: 'generic',
    };

    const defaults = _.pick(config, [
      'authpn',
      'authpt',
      'api_version',
      'user_hash',
    ]);

    const params = _.merge({}, rest, defaults, { region, HKS });

    return {
      params,
      baseURL,
    };
  },
);
